import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row
} from 'reactstrap';

import {showLoader} from "../../../components/loader/loader";
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {connect} from "react-redux";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {ButtonCollapseEye, GenericButton} from "../../../components/buttons/buttonsActions";
import Map3D from "../../../components/map3d/Map3D";
import {traceService} from "../../../jwt/_services/xeeker/traceService";
import {mapFunctions} from "../../../components/map/mapFunctions";
import {pathService} from "../../../jwt/_services/xeeker/pathService";
import {activityService} from "../../../jwt/_services/core/activityService";

const EasyPath = (props) => {
    const { loading } = props.mainProps

    const [googleConfig, setGoogleConfig] = useState( null );
    const [udn, setUdn] = useState( null);
    const [app, setApp] = useState( null);
    const [traces, setTraces] = useState( [] );
    const [markers, setMarkers] = useState( [] );

    // Calculo de Punto A a Punto B
    const [pointA, setPointA] = useState( null );
    const [pointB, setPointB] = useState( null );
    const [routAB, setRoutAB] = useState( null );
    const [show3D, setShow3D] = useState( true );
    const [showActivities, setShowActivities] = useState( true );
    const [showRoutes, setShowRoutes] = useState( false );
    const [showEasyPath, setShowEasyPath] = useState( true );

    const [logoImage, setLogoImage] = useState( null);

    useEffect(() => {
        if (props.app !== null) {
            props.setApp(props.app);
            setApp(props.app)
        }

        const _udn = JSON.parse(localStorage.getItem('selectedUdn'));
        setUdn(_udn);
        props.setUdn(_udn);
        setUdnHeader(_udn);

    },[]);

    useEffect(() => {
        if (udn && app) {
            loadTraces(udn, app);
            loadActivities(udn, app);
        }

        if (udn) {
            loadGoogleConfig( udn );

            navigator.geolocation.getCurrentPosition((navigatorPosition) => {
                // console.log( 'lat:' +  navigatorPosition.coords.latitude,  'lng:' + navigatorPosition.coords.longitude)
                setPointA({
                    lat : parseFloat(navigatorPosition.coords.latitude) ,
                    lng : parseFloat(navigatorPosition.coords.longitude),
                });
            })
        }
    }, [udn, app]);

    const loadTraces = ( _udn, _app ) => {
        if (_udn?.id === undefined || _app?.fbDataBase?.id === undefined)
            return

        const dataRequest = {
            fbDataBase : {  id : _app?.fbDataBase?.id },
            item: {
                udn : { id : _udn.id }
            }
        }

        setLoading(true);
        traceService.search(0, 10000, dataRequest)
            .then(result => {
                if (result){
                    setTraces(result.data);
                }
                setLoading(false);
            })
            .catch(ex => {
                console.log(ex);
                setLoading(false);
            });
    }

    const loadActivities = ( _udn, _app ) => {
        if (_udn?.id === undefined || _app?.fbDataBase?.id === undefined)
            return

        const dataRequest = {
                udns : [
                    { id : _udn.id }
                ]
        }

        activityService.searchMapView(dataRequest)
            .then(result => {
                if (result){
                    setMarkers(mapFunctions.mapResultToMarkers(result.data));
                }
            })
    }

    const loadGoogleConfig = ( _udn ) => {

        let _googleConfig = {}

        if (_udn?.id !== undefined){
            mapFunctions.loadMapConfig(_udn)
                .then(result => {
                    if (result?.data?.length > 0) {
                        let config = result?.data[0];
                        _googleConfig =  {
                            mapOptions: {
                                // center: { lat: 20.581465, lng: -87.120603 },
                                center: {
                                    lat: parseFloat(config?.latitude),
                                    lng: parseFloat(config?.longitude)
                                },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: config.defaultZoom + 1,
                                minZoom: config.minZoom,
                                maxZoom: config.maxZoom + 3
                            },
                            overlay: {
                                udn: config.udnCode.toLowerCase(),
                                pto1: {
                                    lat: config.overlay1Lat,
                                    lng: config.overlay1Long
                                },
                                pto2: {
                                    lat: parseFloat(config.overlay2Lat),
                                    lng: parseFloat(config.overlay2Long)
                                }
                            },
                            bound: {
                                sw: {
                                    lat: parseFloat(config.bound2Lat),
                                    lng: parseFloat(config.bound2Long)
                                },
                                ne: {
                                    lat: parseFloat(config.bound1Lat),
                                    lng: parseFloat(config.bound1Long)
                                }
                            }
                        }

                        setGoogleConfig(_googleConfig);
                    }

                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }

    const onCalculatePath = (  ) => {
        if (udn?.id === undefined || app?.fbDataBase?.id === undefined)
            return

        const dataRequest = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            item: {
                udn : { id : udn.id },
                pointA : { lat : pointA.lat, lng : pointA.lng },
                pointB : { lat : pointB.lat, lng : pointB.lng },
            }
        }

        props.setLoading(true);
        pathService.calculatePath( dataRequest )
            .then(result => {
                if (result){
                    setRoutAB(result);
                }
                props.setLoading(false);
            })
            .catch(_ => {
                props.setLoading(false);
            })
    }

    const setUdnHeader = (_udn) => {
        let img;
        try {
            img = require("../../../assets/images/logo/svg/logo_" + _udn?.code.toLowerCase() + ".svg");
        } catch (e) {
            img = require("../../../assets/images/icon/parks/svg/gpoxc-icon.svg");
        }
        setLogoImage(img);
    }

    const showHideActivities = ( ) => {
        if (showActivities) {
            loadActivities(udn, app);
        }
        setShowActivities(!showActivities);
    }

    const showHideRoutes = ( _marker ) => {
        if (showRoutes) {
            loadTraces(udn, app);
        }

        setShowRoutes(!showRoutes);
    }

    const onMapClick = (e) => {
        console.log(e);
        // setPointA({lat: e.latLng.lat(), lng: e.latLng.lng()});
    }

    const onRightClick = (e) => {
        console.log(e);
        // setPointB({lat: e.latLng.lat(), lng: e.latLng.lng()});
    }

    const onMarkerClick = (e) => {
        console.log(e);
        setPointB( e.position );
    }

    // const onPointAChange = (txtPointA) => {
    //     if (txtPointA.split(',').length === 2){
    //         setPointA({lat: parseFloat(txtPointA.split(',')[0]), lng:  parseFloat(txtPointA.split(',')[1])});
    //     }
    // }
    // const onPointBChange = (txtPointB) => {
    //     if (txtPointB.split(',').length === 2){
    //
    //         setPointB({lat: parseFloat(txtPointB.split(',')[0]), lng:  parseFloat(txtPointB.split(',')[1])});
    //     }
    // }

    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom mb-0">
                    <Row>
                        <Col md="3">
                        </Col>
                        <Col md="6">
                            <img className={'udnlogo'} src={logoImage}  alt={props.udn?.name}/>
                        </Col>
                        <Col>
                            <div className="float-right">
                                <ButtonCollapseEye onClick={showHideActivities} status={showActivities}/>
                                <ButtonCollapseEye onClick={showHideRoutes} status={showRoutes}/>
                                <ButtonCollapseEye onClick={_ => setShowEasyPath(!showEasyPath)} status={showEasyPath}/>
                                <GenericButton onClick={ () => onCalculatePath()} title={''} icon={'fa-code-branch'}/>
                            </div>
                        </Col>
                    </Row>
                </CardTitle>
                <CardBody>
                    {/*<Row>*/}
                    {/*    <Col md="3">*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>{ "Punto A" }</Label>*/}
                    {/*            <Input*/}
                    {/*                type="text"*/}
                    {/*                name="pointA"*/}
                    {/*                value={(pointA?.lat &&  pointA?.lng) ?  (pointA?.lat + ',' + pointA?.lng) : ''}*/}
                    {/*                onChange={e => onPointAChange(e.target.value)}*/}
                    {/*                // innerRef={register}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*    <Col md="3">*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>{ "Punto B" }</Label>*/}
                    {/*            <Input*/}
                    {/*                type="text"*/}
                    {/*                name="pointB"*/}
                    {/*                value={(pointB?.lat &&  pointB?.lng) ?  (pointB?.lat + ',' + pointB?.lng) : ''}*/}
                    {/*                onChange={e => onPointBChange(e.target.value)}*/}
                    {/*                // innerRef={register}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row>
                        <Col md={'12'}>
                            {
                                !loading ?
                                    <Map3D
                                        className="trace-map-container"
                                        markers={[...markers]}
                                        routes={[...traces]}
                                        routAB={routAB}
                                        pointA={pointA}
                                        pointB={pointB}
                                        googleConfig={googleConfig} // solo necesita googleConfig?.mapOptions.center;
                                        onMapClick={onMapClick}
                                        onRightClick={onRightClick}
                                        onMarkerClick={onMarkerClick}
                                        options={{showRouteMarkers: false, show3D : true, showRoutes: showRoutes, showEasyPath: showEasyPath, showActivities: showActivities, udn : udn }}
                                    /> : null
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setApp,
    setCategory,
    setForm,
    setViewMode,
    setLoading,
});

export default connect(mapStateToProps, mapActionsToProps)(EasyPath)
